import TemaComunicacionService from 'src/modules/temaComunicacion/temaComunicacionService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'TEMACOMUNICACION_FORM';

const temaComunicacionFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: temaComunicacionFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await TemaComunicacionService.find(id);
      }

      dispatch({
        type: temaComunicacionFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: temaComunicacionFormActions.INIT_ERROR,
      });

      getHistory().push('/tema-comunicacion');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: temaComunicacionFormActions.CREATE_STARTED,
      });

      await TemaComunicacionService.create(values);

      dispatch({
        type: temaComunicacionFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.temaComunicacion.create.success'),
      );

      getHistory().push('/tema-comunicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: temaComunicacionFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: temaComunicacionFormActions.UPDATE_STARTED,
      });

      await TemaComunicacionService.update(id, values);

      dispatch({
        type: temaComunicacionFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.temaComunicacion.update.success'),
      );

      getHistory().push('/tema-comunicacion');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: temaComunicacionFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default temaComunicacionFormActions;
